// import * as React from "react";
// import Box from "@mui/material/Box";
// import Stepper from "@mui/material/Stepper";
// import Step from "@mui/material/Step";
// import StepLabel from "@mui/material/StepLabel";
// import StepContent from "@mui/material/StepContent";
// import Typography from "@mui/material/Typography";
// import Gridimages from "../Imagesgrid";
// import Storelist from "../../Store/Actions";

// const CustomStepIcon = ({ icon, active, completed, customLabel }) => {
//   return (
//     <div
//       style={{
//         width: 28,
//         height: 28,
//         borderRadius: "50%",
//         backgroundColor: completed
//           ? "#F05A28"
//           : active
//           ? "#F05A28"
//           : "#F05A28",
//         color: "white",
//         fontWeight: "bold",
//         fontSize: 12,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       {customLabel}
//     </div>
//   );
// };

// export default function VerticalLinearStepper() {
//   const { ServiceDetailsStore, setServiceDetailsData_ } = Storelist();

//   //console.logServiceDetailsStore)
//   React.useEffect(() => {
//     console.log(ServiceDetailsStore?.tracking);
//   }, [ServiceDetailsStore]);
//   return (
//     <>
//       {ServiceDetailsStore?.tracking?.length > 0 ? (
//         <Box sx={{ maxWidth: 500 }}>
//           <Stepper orientation="vertical" nonLinear>
//             {[...ServiceDetailsStore?.tracking]
//               ?.reverse()
//               ?.map((step, index,originalArray) => (
//                 <Step key={step.value} active completed={false}>
//                   <StepLabel

//                     components={{ StepIcon: CustomStepIcon }}
//                     slotProps={{
//                       stepIcon: {
//                         icon: `${originalArray?.length  - index}`,
//                       },
//                     }}
//                   >
//                     {step.value}
//                   </StepLabel>

//                   <StepContent>
//                     {step?.image?.length > 0 && (
//                       <Box
//                         sx={{
//                           display: "grid",
//                           gridTemplateColumns: "repeat(3, 1fr)",
//                           gridGap: "10px",
//                           mt: 1,
//                           width: "100%",
//                           borderBottom: "1px solid grey",
//                           paddingBottom: "10px",
//                           placeItems: "center",
//                         }}
//                       >
//                         <Gridimages className="border w-[100%]">
//                           {step?.image?.map((imgs, imgIndex) => (
//                             <a
//                               key={imgIndex}
//                               href={imgs}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               className="w-[80px] border"
//                             >
//                               <img
//                                 alt={`img${imgIndex}`}
//                                 src={imgs}
//                                 className="border"
//                                 style={{
//                                   width: 200,
//                                   height: 60,
//                                   objectFit: "cover",
//                                   borderRadius: 4,
//                                 }}
//                               />
//                             </a>
//                           ))}
//                         </Gridimages>
//                       </Box>
//                     )}
//                     {step?.image2?.length > 0 && (
//                       <Box
//                         sx={{
//                           display: "grid",
//                           gridTemplateColumns: "repeat(3, 1fr)",
//                           gridGap: "10px",
//                           mt: 1,
//                           width: "100%",
//                           // border: "1px solid black",
//                         }}
//                       >
//                         <Gridimages className="border w-[100%]">
//                           {step?.image?.map((imgs, imgIndex) => (
//                             <a
//                               key={imgIndex}
//                               href={imgs}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               className="w-[80px] border"
//                             >
//                               <img
//                                 alt={`img${imgIndex}`}
//                                 src={imgs}
//                                 className="border"
//                                 style={{
//                                   width: 200,
//                                   height: 60,
//                                   objectFit: "cover",
//                                   borderRadius: 4,
//                                 }}
//                               />
//                             </a>
//                           ))}
//                         </Gridimages>
//                       </Box>
//                     )}
//                     {step.comment && (
//                       <div className="border mt-[10px]">
//                         <div className="font-bold">Comments</div>
//                         <div>{step.comment}</div>
//                       </div>
//                     )}
//                   </StepContent>
//                 </Step>
//               ))}
//           </Stepper>
//         </Box>
//       ) : (
//         <div>No Tracking Data Available</div>
//       )}
//     </>
//   );
// }

// import * as React from "react";
// import Box from "@mui/material/Box";
// import Stepper from "@mui/material/Stepper";
// import Step from "@mui/material/Step";
// import StepLabel from "@mui/material/StepLabel";
// import StepContent from "@mui/material/StepContent";
// import Gridimages from "../Imagesgrid";
// import Storelist from "../../Store/Actions";

// // ✅ Correct custom icon component using icon prop
// const CustomStepIcon = ({ icon, active, completed }) => {
//   return (
//     <div
//       style={{
//         width: 28,
//         height: 28,
//         borderRadius: "50%",
//         backgroundColor: "#F05A28",
//         color: "white",
//         fontWeight: "bold",
//         fontSize: 12,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       {icon}
//     </div>
//   );
// };

// export default function VerticalLinearStepper() {
//   const { ServiceDetailsStore } = Storelist();

//   React.useEffect(() => {
//     console.log(ServiceDetailsStore?.tracking);
//   }, [ServiceDetailsStore]);

//   return (
//     <>
//       {ServiceDetailsStore?.tracking?.length > 0 ? (
//         <Box sx={{ maxWidth: 500 }}>
//           <Stepper orientation="vertical" nonLinear>
//             {[...ServiceDetailsStore.tracking]
//               .reverse()
//               .map((step, index, originalArray) => (
//                 <Step key={step.value} active completed={false}>
//                   <StepLabel
//                     components={{ StepIcon: CustomStepIcon }}
//                     slotProps={{
//                       stepIcon: {
//                         icon: `${originalArray.length - index}`, // Custom number
//                       },
//                     }}
//                   >
//                     {step.value}
//                   </StepLabel>

//                   <StepContent>
//                     {/* Image block 1 */}
//                     {step?.image?.length > 0 && (
//                       <Box
//                         sx={{
//                           display: "grid",
//                           gridTemplateColumns: "repeat(3, 1fr)",
//                           gridGap: "10px",
//                           mt: 1,
//                           width: "100%",
//                           borderBottom: "1px solid grey",
//                           paddingBottom: "10px",
//                           placeItems: "center",
//                         }}
//                       >
//                         <Gridimages className="border w-[100%]">
//                           {step.image.map((imgs, imgIndex) => (
//                             <a
//                               key={imgIndex}
//                               href={imgs}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               className="w-[80px] border"
//                             >
//                               <img
//                                 alt={`img${imgIndex}`}
//                                 src={imgs}
//                                 className="border"
//                                 style={{
//                                   width: 200,
//                                   height: 60,
//                                   objectFit: "cover",
//                                   borderRadius: 4,
//                                 }}
//                               />
//                             </a>
//                           ))}
//                         </Gridimages>
//                       </Box>
//                     )}

//                     {/* Image block 2 */}
//                     {step?.image2?.length > 0 && (
//                       <Box
//                         sx={{
//                           display: "grid",
//                           gridTemplateColumns: "repeat(3, 1fr)",
//                           gridGap: "10px",
//                           mt: 1,
//                           width: "100%",
//                         }}
//                       >
//                         <Gridimages className="border w-[100%]">
//                           {step.image2.map((imgs, imgIndex) => (
//                             <a
//                               key={imgIndex}
//                               href={imgs}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               className="w-[80px] border"
//                             >
//                               <img
//                                 alt={`img2-${imgIndex}`}
//                                 src={imgs}
//                                 className="border"
//                                 style={{
//                                   width: 200,
//                                   height: 60,
//                                   objectFit: "cover",
//                                   borderRadius: 4,
//                                 }}
//                               />
//                             </a>
//                           ))}
//                         </Gridimages>
//                       </Box>
//                     )}

//                     {/* Comment Section */}
//                     {step.comment && (
//                       <div className="border mt-[10px]">
//                         <div className="font-bold">Comments</div>
//                         <div>{step.comment}</div>
//                       </div>
//                     )}
//                   </StepContent>
//                 </Step>
//               ))}
//           </Stepper>
//         </Box>
//       ) : (
//         <div>No Tracking Data Available</div>
//       )}
//     </>
//   );
// }

import * as React from "react";
import { Box } from "@mui/material";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Gridimages from "../Imagesgrid";
import Storelist from "../../Store/Actions";
import { styled } from "@mui/material/styles";
import "./style.scss";



export default function VerticalLinearStepper() {
  const { ServiceDetailsStore } = Storelist();

  React.useEffect(() => {
    console.log("Tracking data:", ServiceDetailsStore?.tracking);
  }, [ServiceDetailsStore]);

  const reversedTracking = [...(ServiceDetailsStore?.tracking || [])].reverse();

  return (
    <>
      {reversedTracking && reversedTracking.length > 0 ? (
        <Box sx={{ maxWidth: 500 }}>
          <Stepper orientation="vertical" nonLinear>
            {reversedTracking?.map((step, index) => {
              const customIcon = `${reversedTracking?.length - index}`; // 4, 3, 2, 1...

              return (
                <Step key={step?.value} active completed={false}>
                  <StepLabel
                    // components={{ StepIcon: CustomStepIcon }} // 👈 this sets your custom icon component
                    slotProps={{
                      stepIcon: {
                        sx: {
                          color: "green", // This sets the default icon circle color
                          "&.Mui-active": {
                            color: "#F05A28",
                          },
                          "&.Mui-completed": {
                            color: "blue",
                          },
                        },
                        icon: customIcon,
                      },
                    }}
                  >
                    {step.value}
                  </StepLabel>

                  <StepContent>
                    {step?.image &&
                      Object?.entries(step?.image)?.map(
                        ([key, value], index) => (
                          <Box>
                            <div className="border text-center bg-[#68a0c1] text-[#fff] p-3 font-semibold text-xs rounded-md image-heading">
                              {key}
                            </div>
                            {value?.length > 0 && (
                              <Box
                                sx={{
                                  display: "grid",
                                  gridTemplateColumns: "repeat(3, 1fr)",
                                  gridGap: "10px",
                                  mt: 1,
                                  width: "100%",
                                  padding: "5px",
                                }}
                              >
                                <Gridimages className="border w-[100%] grid grid-cols-3 gap-[10px]">
                                  {value?.map((img, i) => (
                                    <a
                                      key={i}
                                      href={img}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="w-[80px] border"
                                    >
                                      <img
                                        alt={`img2-${i}`}
                                        src={img}
                                        className="border"
                                        style={{
                                          width: 200,
                                          height: 60,
                                          objectFit: "cover",
                                          borderRadius: 4,
                                        }}
                                      />
                                    </a>
                                  ))}
                                </Gridimages>
                              </Box>
                            )}

                            {  step?.comment?.[index] ? (
                              <div className=" border mt-[10px] comments-section flex flex-col rounded-md">
                                <div className="  font-bold  rounded-md">
                                  Comments :
                                </div>
                                <p className=" text-xs break-words">{step?.comment[index]}</p>
                              </div>
                            ) :(<div className=" border mt-[10px] comments-section flex flex-col rounded-md">
                                <div className="  font-bold  rounded-md">
                                  Comments :
                                </div>
                                <p className=" text-xs break-words">{"No comments available"}</p>
                              </div>)}
                            
                            {/* { step?.notes && step?.notes[0] && (
                              <div className=" border mt-[10px] comments-section flex flex-col rounded-md">
                                <div className="  font-bold  rounded-md">
                                  ServiceNotes :
                                </div>
                                <p className=" text-xs break-words">{step?.notes[0]}</p>
                              </div>
                            )} */}
                          </Box>
                        )
                      )}
                  </StepContent>
                </Step>
              );
            })}
          </Stepper>
        </Box>
      ) : (
        <div>No Tracking Data Available</div>
      )}
    </>
  );
}
